class MkBuybar {
  constructor(root) {
    this.root = root;
    this.measure = root.querySelector('[data-mk-buybar-measure]');
    this.primary = document.querySelector('#mk-primary-add');
    this.sticky = root.querySelector('[data-mk-sticky-add]');
    this.seen = false;
    this.above = false;
    this.disabled = false;
    if (!this.measure || !this.primary || !this.sticky) return;
    this.setVisible(false);
    this.observeButton();
    this.observeHeight();
    this.sticky.addEventListener('click', () => {
      if (!this.disabled) this.primary.click();
    });
  }
  setVisible(show) {
    const visible = Boolean(show && !this.disabled);
    this.root.dataset.visible = String(visible);
    this.root.toggleAttribute('inert', !visible);
    this.root.setAttribute('aria-hidden', String(!visible));
    document.body.style.paddingBottom = visible ? `calc(${this.measure.offsetHeight}px + env(safe-area-inset-bottom))` : '';
    if (!visible && this.root.contains(document.activeElement)) this.primary?.focus({preventScroll:true});
  }
  observeButton() {
    this.buttonObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { this.seen = true; this.above = false; }
      else if (this.seen) { this.above = entry.boundingClientRect.bottom <= entry.rootBounds.top; }
      this.setVisible(this.above);
    });
    this.buttonObserver.observe(this.primary);
  }
  observeHeight() {
    this.heightObserver = new ResizeObserver(() => {
      const ratio = this.measure.getBoundingClientRect().height / window.innerHeight;
      if (!this.disabled && ratio > .25) this.disabled = true;
      else if (this.disabled && ratio < .23) this.disabled = false;
      this.root.dataset.heightDisabled = String(this.disabled);
      this.setVisible(this.above);
    });
    this.heightObserver.observe(this.measure);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mk-buybar]').forEach((node) => new MkBuybar(node));
});
